import {
  EyeOutlined,
  LoadingOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Drawer,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Spin,
  Switch,
  Tooltip,
  TreeSelect,
  Upload,
} from "antd";
import React, { useEffect, useState } from "react";
import { useClient } from "../../../Context/ClientContext";
import { dayjs } from "../../../../Utilities/dayjs";
import AssetLocationService, {
  IFALocation,
} from "../../../Services/AssetLocationService";
import FixedAssetsServiceNew, {
  CalcMethod,
  IFAItem,
  IFAListResponse,
} from "../../../Services/FixedAssetsServiceNew";
import {
  handleDecimalValues,
  handleInputFocus,
  updateListWithNewValue,
  Utils,
} from "../../../../Utilities/Utils";
import { IIdNameModel, ItemAdd_Type } from "../../../Services/ItemsService";
import EntryLevelKeys from "../../../Common/EntryLevelKeys";
import { notificationContext } from "../../../Common/Routing/PageRoute";
import {
  ITCEligibility_Type,
  ITCEligibilityTypeOptions,
} from "../../../Services/VoucherServices";
import { useNavigate } from "react-router-dom";
import ChartofAccountServicesNew from "../../../Services/ChartofAccountServicesNew";
import { SearchLedgerByGroupsTypes } from "../../../Services/LedgerService";
import {
  CompanyGSTTypes,
  IBaseDrawerModel,
} from "../../../../Types/CommonConstants";
import AddAssetLocationModal from "../Location/AddAssetLocationModal";
import AssetCategoriesService, {
  ICategoryMaintainCheckbox,
  IFACategoryList,
} from "../../../Services/AssetCategoriesService";
import { dep } from "../Depreciations/Depreciation.js";
import DocumentPreview from "../../../Common/DocumentPreview";
import AddAssetCategoryModal from "../Category/AddAssetCategoryModal";
import OrganisationsService from "../../../Services/Organisations/OrganisationsService";
import AddGroup from "../../Master/Group/AddGroup";
import AddEmpModel from "../../Organisations/AddEmpModel";
import { useHotkey } from "../../../Context/HotKeyContext";

interface IAssetDetailModelProps {
  open: boolean;
  onCancel: any;
  oldPurchaseType: boolean;
  setAssetModelOpen: React.Dispatch<
    React.SetStateAction<{
      open: boolean;
      param: string;
      openingAsset: boolean;
    }>
  >;
  setTrigger?: React.Dispatch<React.SetStateAction<boolean>>;
  editAssetId?: string;
  setNewItem?: React.Dispatch<
    React.SetStateAction<{
      data: {};
      isSaved: boolean;
    }>
  >;
  setEmployee?: React.Dispatch<React.SetStateAction<IIdNameModel[]>>;
  setLocation?: React.Dispatch<React.SetStateAction<IFALocation[]>>;
}

const AddAssetItems = ({
  open,
  onCancel,
  oldPurchaseType,
  setAssetModelOpen,
  setTrigger,
  editAssetId,
  setNewItem,
  setEmployee,
  setLocation,
}: IAssetDetailModelProps) => {
  const { showKeys } = useHotkey();
  const { currentClient, companySettings } = useClient();
  const navigate = useNavigate();
  const [form] = Form.useForm<IFAItem>();
  const defaultfalseCheckBox = {
    maintainLocation: false,
    maintainModel: false,
    maintainIdentityMark: false,
    maintainWarranty: false,
    maintainVariant: false,
    maintainOption: false,
    maintainEmployeeAssign: false,
  };
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  const { openNotification } = React.useContext(notificationContext);
  const [deleteUploadId, setDeleteUploadId] = React.useState<string[]>([]);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [assetLocation, setAssetLocation] = useState<string>("");
  const [addGroupVal, setAddGropVal] = React.useState<any>();
  const [assetCategoryCheckBox, setAssetCategoryCheckBox] =
    useState<ICategoryMaintainCheckbox>(defaultfalseCheckBox);
  const [assetsList, setAssetsList] = useState<IFAListResponse[]>([]);
  const [fixedAssetsGroups, setFixedAssetsGroups] = useState<any>([]);
  const [groupListTrigger, setGroupListTrigger] = useState<boolean>(false);
  const [groupDropdownloading, setGroupDropdownloading] = React.useState(false);
  const [assetAvailable, setAssetAvailable] = useState<boolean>(false);
  const [locationList, setLocationList] = useState<IFALocation[]>([]);
  const [EmployeeList, setEmployeeList] = useState<IIdNameModel[]>([]);
  const [addAssLocation, setAddAssLocation] = useState<IFALocation>({
    locationName: "",
    id: "",
  });
  const [addAssCategory, setAddAssCategory] = useState<IFACategoryList>({
    categoryName: "",
    ...defaultfalseCheckBox,
  });
  const [categoryList, setCategoryList] = useState<IFACategoryList[]>([]);
  const [categoryListLoaded, setCategoryListLoaded] = useState(false);
  const [categorySelected, setCategorySelected] = useState(false);
  const [isModelOpen, setIsModelOpen] = useState<{
    type: string;
    open: boolean;
  }>({
    type: "",
    open: false,
  });
  const [addedEmployee, setAddedEmployee] = useState<IIdNameModel>({
    name: "",
    id: "",
  });
  const [isDepreciable, setDepreciable] = useState<boolean>(false);
  const [saveButtonLoading, setSaveButtonLoading] = useState<boolean>(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [previewImage, setPreviewImage] = React.useState<{
    isBaseConvert: boolean;
    path: any;
  }>({ isBaseConvert: false, path: "" });

  const [depMethod, setDepMethod] = useState<CalcMethod>(
    CalcMethod.WrittenDownValue
  );
  const [assetEmployeeId, setAssetEmployee] = useState(null);
  const [gstCategoryValue, setGSTCategoryValue] = useState<string>("");
  const [fyPeriod, setFYPeriod] = useState<any>({
    from: dayjs(companySettings?.period?.from),
    to: dayjs(companySettings?.period?.to),
  });

  const [openModel, setOpenModel] = useState<{
    type: string;
    open: boolean;
    param?: any;
  }>({
    type: "",
    open: false,
    param: {},
  });

  const gstOption = companySettings?.gsts;
  const handleLocation = (selValue: string) => {
    setAssetLocation(selValue);
  };
  const handleCategory = (selValue: string) => {
    if (selValue) {
      const x = categoryList.find(
        (cat: IFACategoryList) => cat.id === selValue
      );
      if (x) {
        setCategorySelected(true);
        setAssetCategoryCheckBox({
          maintainLocation: x.maintainLocation,
          maintainModel: x.maintainModel,
          maintainIdentityMark: x.maintainIdentityMark,
          maintainWarranty: x.maintainWarranty,
          maintainVariant: x.maintainVariant,
          maintainOption: x.maintainOption,
          maintainEmployeeAssign: x.maintainEmployeeAssign,
        });
      } else {
        setAssetCategoryCheckBox(defaultfalseCheckBox);
      }
    } else {
      setAssetCategoryCheckBox(defaultfalseCheckBox);
    }
  };

  function searchGSTCategory(CategoryData: any, searchId: string): any {
    for (const child of CategoryData) {
      if (child.Id === searchId) {
        return child;
      }
      if (child.Children.length > 0) {
        const result = searchGSTCategory(child.Children, searchId);
        if (result) {
          return result;
        }
      }
    }
  }

  const SetDepRatenLife = (SelCategory: string, SelDepMethod: CalcMethod) => {
    if (SelCategory !== "") {
      const depFilterReco = searchGSTCategory(dep, SelCategory);
      form.setFieldValue("lifeCycleDuration", depFilterReco?.Life);
      form.setFieldValue("depMethod", SelDepMethod);
      if (SelDepMethod === CalcMethod.WrittenDownValue) {
        form.setFieldValue(
          "depRate",
          Math.round(depFilterReco?.WDVRate * 100) / 100
        );
      } else {
        form.setFieldValue(
          "depRate",
          Math.round((100 / depFilterReco?.Life) * 100) / 100
        );
      }
    }
  };

  const handleSLMDepRate = (val: any) => {
    if (depMethod === CalcMethod.StraightLine) {
      form.setFieldValue("depRate", Math.round((100 / val) * 100) / 100);
    } else {
      return;
    }
  };
  useEffect(() => {
    if (addAssCategory.id) {
      const AssetCategoryCheckBox = {
        maintainLocation: addAssCategory.maintainLocation,
        maintainModel: addAssCategory.maintainModel,
        maintainIdentityMark: addAssCategory.maintainIdentityMark,
        maintainWarranty: addAssCategory.maintainWarranty,
        maintainVariant: addAssCategory.maintainVariant,
        maintainOption: addAssCategory.maintainOption,
        maintainEmployeeAssign: addAssCategory.maintainEmployeeAssign,
      };
      setCategoryList((pre: IFACategoryList[]) => {
        let newData = [
          ...pre,
          {
            categoryName: addAssCategory.categoryName,
            id: addAssCategory.id,
            ...AssetCategoryCheckBox,
          },
        ];
        return newData;
      });
      form.setFieldValue("category", addAssCategory.id);
      setAssetCategoryCheckBox({
        ...AssetCategoryCheckBox,
      });
    }
  }, [addAssCategory]);
  const onAssetDepMethodChange = (selValue: CalcMethod) => {
    setDepMethod(selValue);
    SetDepRatenLife(gstCategoryValue, selValue);
  };

  function onAssetGSTCategoryChange(selValue: string) {
    setGSTCategoryValue(selValue);
    SetDepRatenLife(selValue, depMethod);
  }
  // useEffect(() => {
  //   getGroupFixedAssets(currentClient?.id!);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentClient?.id, groupListTrigger]); //, searchSupplier.search]);

  const GetGroupList = (GrpList: any[]) => {
    return GrpList?.map((itm: any) => {
      const list: any = {
        // key: itm?.id,
        id: itm?.id,
        parent: itm?.parent,
        value: itm?.id,
        title: itm?.group_Name,
      };
      if (itm?.children?.length > 0) {
        list.children = GetGroupList([...itm?.children]);
      }
      return list;
    });
  };
  const GetGSTCategoryList = (DepList: any[]) => {
    return DepList?.map((itm: any) => {
      const list: any = {
        key: itm.Id,
        value: itm.Id,
        title: itm.Title,
      };
      if (itm.Children.length > 0) {
        list.children = GetGSTCategoryList([...itm.Children]);
      }
      return list;
    });
  };

  const AssetGSTCategoryOptions = GetGSTCategoryList(dep);

  const fetchLocationnCategory = async () => {
    try {
      setLoading(true);
      const [
        assetGroupListRes,
        locationListRes,
        assetCategoryListRes,
        employeeList,
      ] = await Promise.all([
        ChartofAccountServicesNew.getGroupList(
          currentClient?.id!,
          currentClient?.productModule,
          "",
          "",
          "",
          "",
          SearchLedgerByGroupsTypes.FixedAssets
        ),
        AssetLocationService.getLocationList(currentClient?.id, 0, 0, ""),
        AssetCategoriesService.getCategoriesList(currentClient?.id, 0, 0, ""),
        OrganisationsService.getEmployeesOptionsList(currentClient?.id!),
        getAssetsList(),
      ]);
      // setGroupDropdownloading(true);
      if (assetGroupListRes?.items?.length > 0) {
        setFixedAssetsGroups(GetGroupList(assetGroupListRes?.items));
        // setGroupDropdownloading(false);
        if (!form.getFieldValue("group"))
          form.setFieldValue("group", assetGroupListRes?.items[0]?.id);
      }
      setLocationList(locationListRes?.result);
      setEmployeeList(employeeList || []);

      setCategoryList(assetCategoryListRes?.items || []);
      setCategoryListLoaded(true);
    } catch (ex: any) {
      console.log("Error: ", ex);
      openNotification("error", "Error while fetching data");
    } finally {
      setLoading(false);
    }
  };
  //Update employees data with new Employee
  useEffect(() => {
    setEmployeeList((pre: IIdNameModel[]) => {
      let newData = [...pre, addedEmployee];
      return newData;
    });
    form.setFieldValue("empId", addedEmployee.id);
  }, [addedEmployee]);
  useEffect(() => {
    ChartofAccountServicesNew.getGroupList(
      currentClient?.id!,
      currentClient?.productModule,
      "",
      "",
      "",
      "",
      SearchLedgerByGroupsTypes.FixedAssets
    ).then((res) => {
      if (res?.items?.length > 0) {
        setFixedAssetsGroups(GetGroupList(res?.items));
        // setGroupDropdownloading(false);
        if (addGroupVal?.id) form.setFieldValue("group", addGroupVal?.id);
      }
    });
  }, [groupListTrigger]);

  useEffect(() => {
    if (!editAssetId) {
      setLoading(true);
      FixedAssetsServiceNew.getAssetMaxNo(
        currentClient?.id!,
        dayjs().toISOString()
      )
        .then((res) => {
          form.setFieldValue("number", res?.result);
          // form.setFieldValue("date", dayjs());
          setLoading(false);
        })
        .catch((err: any) => {
          setLoading(false);
          openNotification("error", err.message);
          console.error(err.message);
        });
    }
    fetchLocationnCategory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id]);

  // To update the asset locations list with amended new asset location
  useEffect(() => {
    // setLoading(true);
    if (addAssLocation.id) {
      setLocationList((prev) =>
        updateListWithNewValue(prev, addAssLocation, true).sort((a, b) =>
          a.locationName.localeCompare(b.locationName)
        )
      );
      form.setFieldValue("location", addAssLocation.id);
    }
    // setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addAssLocation]);

  // To update the asset locations list with amended new asset location
  useEffect(() => {
    // setLoading(true);
    if (addAssLocation.id) {
      setCategoryList((prev) =>
        updateListWithNewValue(prev, addAssCategory, true).sort((a, b) =>
          a.categoryName.localeCompare(b.categoryName)
        )
      );
      form.setFieldValue("category", addAssCategory.id);
    }
    // setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addAssCategory]);

  // Post Api
  const onSubmit = () => {
    form.validateFields().then(async (values) => {
      try {
        setLoading(true);
        setSaveButtonLoading(true);
        let selGST = gstOption?.find((gst: any) => gst.id === values?.taxRate);
        const postAsset: IFAItem = {
          ...values,
          itemAddType: oldPurchaseType
            ? ItemAdd_Type.Opening
            : ItemAdd_Type.New,
          taxRate: { ...selGST },
          isDepreciable: isDepreciable,
          deleteUploadId: deleteUploadId,
          warranty: values?.warranty
            ? dayjs(values?.warranty).toISOString()
            : undefined,
          openingDetails: values?.openingDetails?.map((opDetail) => ({
            ...opDetail,
            purchaseDate: opDetail?.purchaseDate
              ? dayjs(opDetail?.purchaseDate).toISOString()
              : undefined,
            wdvDate: opDetail?.wdvDate
              ? dayjs(opDetail?.wdvDate).toISOString()
              : undefined,
            itemDetail: {
              ...opDetail.itemDetail,
              warranty: opDetail?.itemDetail?.warranty
                ? dayjs(opDetail?.itemDetail?.warranty).toISOString()
                : undefined,
              depreciationStartDate: opDetail?.wdvDate
                ? dayjs(opDetail?.wdvDate).toISOString()
                : undefined,
            },
          })),
        };
        console.log("Post Values: ", postAsset);

        await FixedAssetsServiceNew.PostFixedAssets(
          currentClient?.id!,
          postAsset,
          editAssetId
        )
          .then((res) => {
            console.log("res", res);
            if (res.result) {
              openNotification(
                "success",
                `Asset ${res.result?.name} ${
                  editAssetId ? "updated successfully." : "added successfully."
                }`
              );
              form.resetFields();
              setNewItem &&
                setNewItem({
                  data: {
                    ...postAsset,
                    ...assetCategoryCheckBox,
                    id: res.result.id,
                  },
                  isSaved: true,
                });
              if (addAssLocation.id && setLocation) {
                setLocation((pre: IFALocation[]) => {
                  let newData = [...pre, addAssLocation];
                  return newData;
                });
              }
              if (addedEmployee.id && setEmployee) {
                setEmployee((pre: IIdNameModel[]) => {
                  let newData = [...pre, addedEmployee];
                  return newData;
                });
              }
              setTrigger && setTrigger((prev: boolean) => !prev);
              setAssetModelOpen({
                open: false,
                param: "",
                openingAsset: false,
              });
              setSaveButtonLoading(false);
            } else if (res.message) {
              openNotification("error", res?.message);
              setLoading(false);
              setSaveButtonLoading(false);
            }
          })
          .catch((ex) => {
            console.log("Error : ", ex);
            openNotification("error", ex);
            setSaveButtonLoading(false);
            setLoading(false);
          });
      } catch (error) {
        openNotification("error", error);
        setSaveButtonLoading(false);
        setLoading(false);
      }
    });
  };
  // useKeyboardShortcuts("s", ["altKey"], () => onSubmit());
  EntryLevelKeys({
    save: onSubmit,
    cancel: () => onCancel(false),
  });

  // Edit
  React.useEffect(() => {
    if (editAssetId && categoryListLoaded) {
      setLoading(true);
      const getAssestDetails = async () => {
        let res = await FixedAssetsServiceNew?.getAssetDetails(
          currentClient?.id!,
          // location?.state?.data?.id
          editAssetId
        );
        if (res.status) {
          // setInvoiceDetail(res?.result?.invoiceDetail);
          setDepMethod(res?.result?.depMethod!);
          setDepreciable(res?.result?.isDepreciable);
          setCategorySelected(res?.result?.category ? true : false);
          const x = categoryList.find(
            (cat: IFACategoryList) => cat.id === res?.result?.category
          );
          console.log("categoryList", x);
          if (x) {
            setAssetCategoryCheckBox({
              maintainLocation: x.maintainLocation,
              maintainModel: x.maintainModel,
              maintainIdentityMark: x.maintainIdentityMark,
              maintainWarranty: x.maintainWarranty,
              maintainVariant: x.maintainVariant,
              maintainOption: x.maintainOption,
              maintainEmployeeAssign: x.maintainEmployeeAssign,
            });
          }
          form?.setFieldsValue({
            ...res?.result,
            warranty:
              dayjs(res?.result?.warranty).unix() > 1
                ? dayjs(res?.result?.warranty)
                : undefined,
            taxRate: res?.result?.taxRate && res?.result?.taxRate?.id,
            openingDetails: res?.result?.openingDetails?.map((opDetail) => ({
              ...opDetail,
              purchaseDate: opDetail?.purchaseDate
                ? dayjs(opDetail?.purchaseDate)
                : undefined,
              wdvDate: opDetail?.wdvDate ? dayjs(opDetail?.wdvDate) : undefined,
              itemDetail: {
                ...opDetail.itemDetail,
                warranty: opDetail.itemDetail?.warranty
                  ? dayjs(opDetail.itemDetail?.warranty)
                  : "",
                depreciationStartDate: opDetail?.wdvDate
                  ? dayjs(opDetail?.wdvDate)
                  : "",
              },
            })),
          });
          setLoading(false);
        } else {
          setLoading(false);
        }
      };
      getAssestDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editAssetId, categoryListLoaded]);

  const handleAssetNameDuplicate = async (e: any) => {
    let ledDetail = assetsList
      ?.filter((led) => led.id !== editAssetId)
      .filter(
        (led) =>
          led.name.toLowerCase().trim() ===
          e?.target?.value.trim().toLowerCase()
      );
    setAssetAvailable(ledDetail?.length! > 0 ? true : false);
  };

  const getAssetsList = async () => {
    const assetListRes = await FixedAssetsServiceNew.getFixedAssetsList(
      currentClient?.id!,
      0,
      0
    );
    setAssetsList(assetListRes?.result?.items);
  };

  return (
    <>
      <Drawer
        onClose={() => onCancel()}
        open={open}
        width={"60vw"}
        title={`${editAssetId ? "Update" : "Add"} Asset Item`}
        maskClosable={false}
        extra={
          <Space>
            <>
              <Tooltip
                title={<p>ALT+C</p>}
                placement="bottomLeft"
                open={showKeys}
                // trigger={[]}
              >
                <Button
                  onClick={() => {
                    form.resetFields();
                    setAssetModelOpen({
                      open: false,
                      param: "",
                      openingAsset: false,
                    });
                  }}
                >
                  Cancel
                </Button>
              </Tooltip>
            </>
            <>
              <Tooltip
                title={<p>ALT+S</p>}
                placement="bottomLeft"
                open={showKeys}
              >
                <Button
                  type="primary"
                  disabled={loading}
                  loading={saveButtonLoading}
                  onClick={() => onSubmit()}
                >
                  {`${editAssetId ? "Update" : "Add"}`}
                </Button>
              </Tooltip>
            </>
          </Space>
        }
      >
        <Spin indicator={antIcon} spinning={loading}>
          <Form
            name="assetDetail"
            disabled={loading}
            layout="vertical"
            form={form}
            // initialValues={{ ...currChildData }}
            initialValues={{
              taxCredit: ITCEligibility_Type.Available,
              residualValue: 0,
              openingDetails: [
                {
                  itemDetail: {},
                },
              ],
            }}
          >
            <Row gutter={6}>
              <Col lg={8} md={8}>
                <Form.Item
                  name="name"
                  label="Asset Name"
                  className="inputboxmb"
                  rules={[
                    {
                      required: true,
                      message:
                        "Asset name is required. Only alphanumeric characters with space, (, ), _, / and - are allowed.",
                      pattern:
                        /^[A-Za-z][A-Za-z0-9_/()-]+(?:\s[A-Za-z0-9_/()-]+)*$/,
                    },
                    {
                      min: 3,
                      max: 30,
                      message: "Required length is minimum 3 and maximum 30",
                    },
                    {
                      validator: () => {
                        if (assetAvailable) {
                          return Promise.reject("Name already exists.");
                        } else {
                          return Promise.resolve();
                        }
                      },
                    },
                  ]}
                >
                  <Input onChange={handleAssetNameDuplicate}></Input>
                </Form.Item>
              </Col>
              <Col lg={8} md={8}>
                <Form.Item
                  name="number"
                  label="Asset Number"
                  className="inputboxmb"
                >
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col lg={8} md={8}>
                <Form.Item
                  name="isDepreciable"
                  valuePropName="checked"
                  style={{ display: "flex", flexDirection: "row" }}
                  labelCol={{ lg: 24 }}
                  wrapperCol={{ lg: 24 }}
                  className="inputboxmb"
                >
                  <span>
                    Depreciable Asset
                    <br />
                    <Switch
                      style={{ margin: "10px 4px 0px" }}
                      checked={isDepreciable}
                      onChange={(isChecked) => {
                        setDepreciable(isChecked);
                      }}
                    />
                  </span>
                </Form.Item>
              </Col>
              <Col lg={8} md={8}>
                <Form.Item
                  name="group"
                  label="Asset Group"
                  rules={[
                    {
                      required: true,
                      message: "Please select group",
                    },
                  ]}
                  className="inputboxmb"
                >
                  <TreeSelect
                    //className="inputboxsize"
                    treeNodeFilterProp="title"
                    showSearch
                    placeholder="Please select asset group"
                    allowClear
                    // value={groupValue}
                    //treeDefaultExpandAll
                    loading={groupDropdownloading}
                    style={{ marginBottom: "3px" }}
                    treeData={fixedAssetsGroups}
                    // onChange={onAssetGroupChange}
                    dropdownRender={(groupOptions) => (
                      <>
                        {groupOptions}
                        <Divider style={{ margin: "5px 0px" }} />
                        <Button
                          style={{ width: "100%" }}
                          icon={<PlusOutlined />}
                          type="link"
                          onClick={() =>
                            setOpenModel({
                              type: "addGroup",
                              open: true,
                            })
                          }
                        >
                          New Group
                        </Button>
                      </>
                    )}
                    dropdownStyle={{
                      maxHeight: 400,
                      overflow: "auto",
                    }}
                  />
                </Form.Item>
              </Col>
              <Col lg={8} md={8}>
                <Form.Item
                  name="category"
                  label="Category"
                  className="inputboxmb"
                >
                  <Select
                    style={{ marginBottom: "3px" }}
                    allowClear
                    onChange={(e) => handleCategory(e)}
                    options={categoryList?.map((l: any) => ({
                      value: l.id,
                      label: l.categoryName,
                      title: "",
                    }))}
                    placeholder="Please select category"
                    dropdownRender={(itemsOption) => (
                      <>
                        {itemsOption}
                        <Divider
                          style={{
                            margin: "5px 0px",
                          }}
                        />
                        <Button
                          style={{ width: "100%" }}
                          icon={<PlusOutlined />}
                          type="link"
                          onClick={() =>
                            setIsModelOpen({ open: true, type: "AddCategory" })
                          }
                        >
                          Add Category
                        </Button>
                      </>
                    )}
                  />
                </Form.Item>
              </Col>
              {checkCategoryCheckboxMaintain(
                assetCategoryCheckBox?.maintainLocation,
                form.getFieldValue("location"),
                editAssetId
              ) &&
                !oldPurchaseType && (
                  <Col lg={8} md={8}>
                    <Form.Item
                      name="location"
                      label="Location"
                      className="inputboxmb"
                    >
                      <Select
                        allowClear
                        style={{ marginBottom: "3px" }}
                        onChange={handleLocation}
                        options={locationList?.map((l: any) => ({
                          value: l.id,
                          label: l.locationName,
                          title: "",
                        }))}
                        dropdownRender={(itemsOption) => (
                          <>
                            {itemsOption}
                            <Divider
                              style={{
                                margin: "5px 0px",
                              }}
                            />
                            <Button
                              style={{ width: "100%" }}
                              icon={<PlusOutlined />}
                              type="link"
                              onClick={() =>
                                setIsModelOpen({
                                  open: true,
                                  type: "AddLocation",
                                })
                              }
                            >
                              Add Location
                            </Button>
                          </>
                        )}
                      />
                    </Form.Item>
                  </Col>
                )}
              {checkCategoryCheckboxMaintain(
                assetCategoryCheckBox?.maintainModel,
                form.getFieldValue("assetModel"),
                editAssetId
              ) && (
                <Col lg={8} md={8}>
                  <Form.Item
                    name="assetModel"
                    label="Model"
                    className="inputboxmb"
                    rules={[
                      {
                        min: 2,
                        max: 30,
                        message: "Length must be between 2 and 30",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              )}
              {/* {checkCategoryCheckboxMaintain(
                assetCategoryCheckBox?.maintainModel,
                form.getFieldValue("identityCode"),
                editAssetId
              ) && (
                <Col lg={8} md={8}>
                  <Form.Item
                    name="identityCode"
                    label="Identity Code"
                    className="inputboxmb"
                    rules={[
                      {
                        min: 3,
                        max: 30,
                        message: "Length must be between 2 and 30",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              )} */}
              {checkCategoryCheckboxMaintain(
                assetCategoryCheckBox?.maintainWarranty,
                form.getFieldValue("warranty"),
                editAssetId
              ) &&
                !oldPurchaseType && (
                  <Col lg={8} md={8}>
                    <Form.Item
                      name="warranty"
                      label="Warranty"
                      className="inputboxmb"
                    >
                      <DatePicker
                        format="DD/MM/YYYY"
                        style={{ width: "100%" }}
                        disabledDate={(current) =>
                          current <
                          dayjs("1900-01-01", "YYYY-MM-DD").add(-1, "day")
                        }
                      />
                    </Form.Item>
                  </Col>
                )}
              {checkCategoryCheckboxMaintain(
                assetCategoryCheckBox?.maintainVariant,
                form.getFieldValue("assetVariant"),
                editAssetId
              ) && (
                <Col lg={8} md={8}>
                  <Form.Item
                    name="assetVariant"
                    label="Variant"
                    className="inputboxmb"
                    rules={[
                      {
                        min: 2,
                        max: 30,
                        message: "Length must be between 2 and 30",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              )}
              {checkCategoryCheckboxMaintain(
                assetCategoryCheckBox?.maintainOption,
                form.getFieldValue("assetOption"),
                editAssetId
              ) && (
                <Col lg={8} md={8}>
                  <Form.Item
                    name="assetOption"
                    label="Option"
                    className="inputboxmb"
                    rules={[
                      {
                        min: 2,
                        max: 30,
                        message: "Length must be between 2 and 30",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              )}

              {checkCategoryCheckboxMaintain(
                assetCategoryCheckBox?.maintainEmployeeAssign,
                form.getFieldValue("empId"),
                editAssetId
              ) &&
                !oldPurchaseType && (
                  <Col lg={8} md={8}>
                    <Form.Item
                      name="empId"
                      label="Assigned Employee"
                      className="inputboxmb"
                    >
                      <Select
                        allowClear
                        style={{ marginBottom: "3px" }}
                        onChange={handleLocation}
                        options={EmployeeList?.map((l: any) => ({
                          value: l.id,
                          label: l.name,
                          title: "",
                        }))}
                        dropdownRender={(itemsOption) => (
                          <>
                            {itemsOption}
                            <Divider
                              style={{
                                margin: "5px 0px",
                              }}
                            />
                            <Button
                              style={{ width: "100%" }}
                              icon={<PlusOutlined />}
                              type="link"
                              onClick={() => {
                                console.log("add employee clicked");
                                setIsModelOpen({
                                  type: "AddEmployee",
                                  open: true,
                                });
                              }}
                            >
                              Add Employee
                            </Button>
                          </>
                        )}
                      />
                    </Form.Item>
                  </Col>
                )}
            </Row>
            <Row gutter={6}>
              <Col lg={8} md={12}>
                <Form.Item
                  name="purPrice"
                  label={
                    <>
                      <span>{"Purchase Price "} &nbsp;</span>
                      <Tooltip title="Only for viewing this price in voucher">
                        <EyeOutlined />
                      </Tooltip>
                    </>
                  }
                  className="inputboxmb"
                  style={{ width: "100%" }}
                >
                  <Input
                    addonAfter="INR"
                    onFocus={(e) => {
                      handleInputFocus(e, form);
                    }}
                    onBlur={(e) => {
                      form.setFieldValue(
                        "purPrice",
                        Utils.getFormattedNumber(
                          Utils.getNumber(e.target.value)
                        )
                      );
                    }}
                    onKeyPress={(e: any) => {
                      if (!/\d|\./.test(e.key)) e.preventDefault();
                      if (e.key === "." && e.target.value.includes("."))
                        e.preventDefault();
                      if (
                        parseInt(
                          Utils.getNumber(e.target.value).toString()
                        ).toString().length > 9
                      )
                        e.preventDefault();
                    }}
                  />
                </Form.Item>
              </Col>
              <Col lg={16} md={12}>
                <Form.Item
                  name="description"
                  label="Description"
                  className="inputboxmb"
                  rules={[
                    {
                      min: 3,
                      max: 250,
                      message: "Required length is minimum 0 and maximum 250",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>
            {currentClient?.gstType === CompanyGSTTypes.Regular && (
              <Row gutter={6}>
                <Col lg={8} md={8}>
                  <Form.Item
                    name="taxRate"
                    label="GST"
                    className="inputboxmb"
                    rules={[
                      {
                        required:
                          currentClient?.gstType === CompanyGSTTypes.Regular ||
                          currentClient?.gstType === CompanyGSTTypes.Composition
                            ? true
                            : false,
                        message: "Please select GST Rate",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select GST Rate"
                      disabled={gstOption === null ? true : false}
                      style={{ marginBottom: "3px" }}
                      options={gstOption?.map((gst: any, index: number) => ({
                        key: index,
                        value: gst.id,
                        label: gst.name,
                        title: "",
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col lg={8} md={8}>
                  <Form.Item
                    htmlFor="hsnCode"
                    name="hsnCode"
                    label="HSN Code"
                    className="input-item"
                    rules={[
                      {
                        required:
                          currentClient?.gstType === CompanyGSTTypes.Regular ||
                          currentClient?.gstType === CompanyGSTTypes.Composition
                            ? true
                            : false,
                        message: "HSN code is required",
                      },
                      {
                        pattern: /^(?!0+$)(\d{4}|\d{6}|\d{8})$/,
                        message:
                          "Enter valid HSN code with minimum 4 and maximum 8 digits",
                      },
                    ]}
                  >
                    <Input
                      placeholder="HSN code"
                      maxLength={8}
                      // controls={false}
                      // addonAfter={<SearchOutlined />}
                      onChange={(e) => {
                        const newValue = e.target.value.replace(/[^0-9]/g, "");
                        form.setFieldValue("hsnCode", newValue);
                      }}
                      // onKeyPress={(e) =>
                      //   !/[A-Za-z\s]/.test(e.key) && e.preventDefault()
                      // }
                    />
                  </Form.Item>
                </Col>
                <Col lg={8} md={8}>
                  <Form.Item
                    name="taxCredit"
                    label="Tax Credit"
                    className="inputboxmb"
                  >
                    <Select
                      //className="inputboxsize"
                      disabled={gstOption == null ? true : false}
                      placeholder="Please select"
                      options={ITCEligibilityTypeOptions}
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}

            <Row>
              {isDepreciable && (
                <>
                  <Card
                    title="Depreciation Detail"
                    size="small"
                    style={{ marginTop: "10px", width: "100%" }}
                  >
                    <Row gutter={6}>
                      <Col lg={24} md={24}>
                        <Form.Item
                          name="gstCategory"
                          label="Asset Category"
                          rules={[
                            {
                              required: true,
                              message: "Asset category is mandatory",
                            },
                          ]}
                          className="inputboxmb"
                        >
                          <TreeSelect
                            //className="inputboxsize"
                            treeNodeFilterProp="title"
                            showSearch
                            placeholder="Please select asset category"
                            allowClear
                            value={gstCategoryValue}
                            treeDefaultExpandAll
                            style={{ marginBottom: "3px" }}
                            treeData={AssetGSTCategoryOptions}
                            onChange={(cat: string) =>
                              onAssetGSTCategoryChange(cat)
                            }
                            dropdownStyle={{
                              maxHeight: 400,
                              overflow: "auto",
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col lg={8} md={8}>
                        <Form.Item
                          name="depMethod"
                          label="Depreciation Method"
                          rules={[
                            {
                              required: true,
                              message: "Please select depreciation method",
                            },
                          ]}
                          className="inputboxmb"
                        >
                          <Select
                            //className="inputboxsize"
                            style={{ marginBottom: "3px" }}
                            onChange={(val) => onAssetDepMethodChange(val)}
                            placeholder="Please select depreciation method"
                            //defaultValue={CalcMethod.WrittenDownValue}
                            options={[
                              {
                                value: CalcMethod.StraightLine,
                                label: "Straight Line Method",
                                title: "",
                              },
                              {
                                value: CalcMethod.WrittenDownValue,
                                label: "Written Down Method",
                                title: "",
                              },
                            ]}
                          />
                        </Form.Item>
                      </Col>
                      <Col lg={8} md={8}>
                        <Form.Item
                          name="lifeCycleDuration"
                          label="Asset Life in year"
                          className="inputboxmb"
                          rules={[
                            {
                              required:
                                depMethod === CalcMethod.StraightLine
                                  ? true
                                  : false,
                              message: "Asset life required",
                            },
                          ]}
                        >
                          <InputNumber
                            min={0}
                            max={100}
                            precision={0}
                            style={{ width: "100%" }}
                            onFocus={(e: any) => handleInputFocus(e, form)}
                            onBlur={(val: any) =>
                              handleSLMDepRate(val?.target?.value)
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col lg={8} md={8}>
                        <Form.Item
                          name="depRate"
                          label="Depreciation Rate"
                          rules={[
                            {
                              required: true,
                              message: "Please input depreciation rate",
                            },
                          ]}
                          className="inputboxmb"
                        >
                          <InputNumber
                            style={{ width: "100%" }}
                            min={0}
                            max={100}
                            onFocus={(e: any) => handleInputFocus(e, form)}
                            type="number"
                            // onKeyPress={(e: any) => {
                            //   if (!/\d|\./.test(e.key)) e.preventDefault();
                            //   if (e.key === "." && e.target.value.includes("."))
                            //     e.preventDefault();
                            // }}
                          />
                        </Form.Item>
                      </Col>
                      {depMethod === CalcMethod.StraightLine &&
                        !oldPurchaseType && (
                          <>
                            <Col lg={8} md={8}>
                              <Form.Item
                                name="residualValue"
                                label="Residual Value"
                                className="inputboxmb"
                                rules={[
                                  {
                                    required: true,
                                    message: "Residual value is required",
                                  },
                                  {
                                    validator: (_, value) => {
                                      if (value && value < 0) {
                                        return Promise.reject(
                                          "Residual value can't be negative."
                                        );
                                      }
                                      return Promise.resolve();
                                    },
                                  },
                                ]}
                              >
                                <Input
                                  style={{ width: "100%" }}
                                  onFocus={(e) => {
                                    handleInputFocus(e, form);
                                  }}
                                  onBlur={(e) => {
                                    form.setFieldValue(
                                      "residualValue",
                                      Utils.getFormattedNumber(
                                        Utils.getNumber(e.target.value)
                                      )
                                    );
                                  }}
                                  onKeyPress={(e: any) => {
                                    if (!/\d|\./.test(e.key))
                                      e.preventDefault();
                                    if (
                                      e.key === "." &&
                                      e.target.value.includes(".")
                                    )
                                      e.preventDefault();
                                    if (
                                      parseInt(
                                        Utils.getNumber(
                                          e.target.value
                                        ).toString()
                                      ).toString().length > 9
                                    )
                                      e.preventDefault();
                                  }}
                                />
                              </Form.Item>
                            </Col>
                          </>
                        )}
                      {/* <Col lg={8} md={8}>
                      <Form.Item
                        name="depreciationStartDate"
                        label="Depreciation Start Date"
                        className="inputboxmb"
                        rules={[
                          {
                            required: true,
                            message: "Depreciation date is required",
                          },
                        ]}
                      >
                        <DatePicker
                          // defaultValue={dayjs()}
                          disabledDate={(current) =>
                            dayjs(assetPurDate) < dayjs(fyPeriod.from)
                              ? current < dayjs(fyPeriod.from)
                              : current < dayjs(assetPurDate).startOf("day")
                          }
                          style={{ width: "100%" }}
                          allowClear={false}
                          format={"DD/MM/YYYY"}
                        />
                      </Form.Item>
                    </Col> */}
                    </Row>
                  </Card>
                </>
              )}
            </Row>
            <Row>
              {oldPurchaseType && (
                <Card
                  title="Opening Stock detail"
                  size="small"
                  style={{ marginTop: "10px", width: "100%" }}
                >
                  <Form.List name="openingDetails">
                    {(fields, { add, remove }, { errors }) => (
                      <>
                        {fields.map((field, index) => (
                          <>
                            <Row gutter={6}>
                              <Col lg={8} md={8}>
                                <Form.Item
                                  name={[index, "invNumber"]}
                                  label="Invoice No."
                                  className="inputboxmb"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Invoice No. is required",
                                    },
                                    {
                                      min: 3,
                                      max: 30,
                                      message:
                                        "Length must be between 3 and 30",
                                    },
                                  ]}
                                >
                                  <Input />
                                </Form.Item>
                              </Col>
                              <Col lg={8} md={8}>
                                <Form.Item
                                  name={[index, "purchaseDate"]}
                                  label="Purchase Date"
                                  className="inputboxmb"
                                >
                                  <DatePicker
                                    format="DD/MM/YYYY"
                                    style={{ width: "100%" }}
                                    disabledDate={(current) =>
                                      current <
                                      dayjs("1900-01-01", "YYYY-MM-DD").add(
                                        -1,
                                        "day"
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col lg={8} md={8}>
                                <Form.Item
                                  name={[index, "openingPurchasePrice"]}
                                  label={
                                    <>
                                      <span>Purchase Price &nbsp;</span>
                                      <Tooltip title="Actual purchase price">
                                        <EyeOutlined />
                                      </Tooltip>
                                    </>
                                  }
                                  className="inputboxmb"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Purchase price is required",
                                    },
                                  ]}
                                >
                                  <Input type="number" min={0} />
                                </Form.Item>
                              </Col>
                              <Col lg={8} md={8}>
                                <Form.Item
                                  name={[index, "openingQty"]}
                                  label="Quantity"
                                  className="inputboxmb"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Quantity is required",
                                    },
                                  ]}
                                >
                                  <Input type="number" min={0} />
                                </Form.Item>
                              </Col>
                              {isDepreciable && (
                                <Col lg={8} md={8}>
                                  <Form.Item
                                    name={[index, "accumulatedDepreciation"]}
                                    label="Accumulated Depreciation"
                                    className="inputboxmb"
                                    rules={[
                                      {
                                        required: true,
                                        message:
                                          "Accumulated depreciation value is required",
                                      },
                                    ]}
                                  >
                                    <Input type="number" min={0} />
                                  </Form.Item>
                                </Col>
                              )}
                              <Col lg={8} md={8}>
                                <Form.Item
                                  name={[index, "wdvDate"]}
                                  label="Opening detail as on"
                                  initialValue={dayjs(
                                    companySettings?.period?.from
                                  )}
                                  className="inputboxmb"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Opening date is required",
                                    },
                                  ]}
                                >
                                  <DatePicker
                                    disabled
                                    format="DD/MM/YYYY"
                                    style={{ width: "100%" }}
                                    disabledDate={(current) =>
                                      current <
                                      dayjs("1900-01-01", "YYYY-MM-DD").add(
                                        -1,
                                        "day"
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              {depMethod === CalcMethod.StraightLine && (
                                <Col lg={8} md={8}>
                                  <Form.Item
                                    name={[
                                      index,
                                      "itemDetail",
                                      "residualValue",
                                    ]}
                                    label="Residual Value"
                                    className="inputboxmb"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Residual value is required",
                                      },
                                      {
                                        validator: (_, value) => {
                                          if (value && value < 0) {
                                            return Promise.reject(
                                              "Residual value can't be negative."
                                            );
                                          }
                                          return Promise.resolve();
                                        },
                                      },
                                    ]}
                                  >
                                    <InputNumber
                                      style={{ width: "100%" }}
                                      min={0}
                                      precision={2}
                                      onFocus={(e) => {
                                        handleInputFocus(e, form);
                                      }}
                                      onKeyPress={handleDecimalValues}
                                    />
                                  </Form.Item>
                                </Col>
                              )}
                              {categorySelected && (
                                <>
                                  <Divider>
                                    <h6>Other Detail</h6>
                                  </Divider>

                                  {checkCategoryCheckboxMaintain(
                                    assetCategoryCheckBox?.maintainLocation,
                                    form.getFieldValue([
                                      "openingDetails",
                                      index,
                                      "itemDetail",
                                      "location",
                                    ]),
                                    editAssetId
                                  ) &&
                                    oldPurchaseType && (
                                      <Col lg={8} md={8}>
                                        <Form.Item
                                          name={[
                                            index,
                                            "itemDetail",
                                            "location",
                                          ]}
                                          label="Location"
                                          className="inputboxmb"
                                        >
                                          <Select
                                            allowClear
                                            style={{ marginBottom: "3px" }}
                                            onChange={handleLocation}
                                            options={locationList?.map(
                                              (l: any) => ({
                                                value: l.id,
                                                label: l.locationName,
                                                title: "",
                                              })
                                            )}
                                            dropdownRender={(itemsOption) => (
                                              <>
                                                {itemsOption}
                                                <Divider
                                                  style={{
                                                    margin: "5px 0px",
                                                  }}
                                                />
                                                <Button
                                                  style={{ width: "100%" }}
                                                  icon={<PlusOutlined />}
                                                  type="link"
                                                  onClick={() =>
                                                    setIsModelOpen({
                                                      open: true,
                                                      type: "AddLocation",
                                                    })
                                                  }
                                                >
                                                  Add Location
                                                </Button>
                                              </>
                                            )}
                                          />
                                        </Form.Item>
                                      </Col>
                                    )}
                                  {checkCategoryCheckboxMaintain(
                                    assetCategoryCheckBox?.maintainIdentityMark,
                                    form.getFieldValue([
                                      "openingDetails",
                                      index,
                                      "itemDetail",
                                      "identityCode",
                                    ]),
                                    editAssetId
                                  ) &&
                                    oldPurchaseType && (
                                      <Col lg={8} md={8}>
                                        <Form.Item
                                          name={[
                                            index,
                                            "itemDetail",
                                            "identityCode",
                                          ]}
                                          label="Identity Code"
                                          className="inputboxmb"
                                          rules={[
                                            {
                                              min: 3,
                                              max: 30,
                                              message:
                                                "Length must be between 2 and 30",
                                            },
                                          ]}
                                        >
                                          <Input />
                                        </Form.Item>
                                      </Col>
                                    )}
                                  {checkCategoryCheckboxMaintain(
                                    assetCategoryCheckBox?.maintainWarranty,
                                    form.getFieldValue([
                                      "openingDetails",
                                      index,
                                      "itemDetail",
                                      "warranty",
                                    ]),
                                    editAssetId
                                  ) &&
                                    oldPurchaseType && (
                                      <Col lg={8} md={8}>
                                        <Form.Item
                                          name={[
                                            index,
                                            "itemDetail",
                                            "warranty",
                                          ]}
                                          label="Warranty"
                                          className="inputboxmb"
                                        >
                                          <DatePicker
                                            format="DD/MM/YYYY"
                                            style={{ width: "100%" }}
                                            disabledDate={(current) =>
                                              current <
                                              dayjs(
                                                "1900-01-01",
                                                "YYYY-MM-DD"
                                              ).add(-1, "day")
                                            }
                                          />
                                        </Form.Item>
                                      </Col>
                                    )}

                                  {checkCategoryCheckboxMaintain(
                                    assetCategoryCheckBox?.maintainEmployeeAssign,
                                    form.getFieldValue([
                                      "openingDetails",
                                      index,
                                      "itemDetail",
                                      "empId",
                                    ]),
                                    editAssetId
                                  ) &&
                                    oldPurchaseType && (
                                      <Col lg={8} md={8}>
                                        <Form.Item
                                          name={[index, "itemDetail", "empId"]}
                                          label="Assigned Employee"
                                          className="inputboxmb"
                                        >
                                          <Select
                                            allowClear
                                            style={{ marginBottom: "3px" }}
                                            onChange={handleLocation}
                                            options={EmployeeList?.map(
                                              (l: any) => ({
                                                value: l.id,
                                                label: l.name,
                                                title: "",
                                              })
                                            )}
                                            dropdownRender={(itemsOption) => (
                                              <>{itemsOption}</>
                                            )}
                                          />
                                        </Form.Item>
                                      </Col>
                                    )}
                                </>
                              )}
                            </Row>
                            {categorySelected && (
                              <>
                                <Space>
                                  <Button type="primary" onClick={() => add()}>
                                    <PlusCircleOutlined />
                                  </Button>
                                  {index < fields.length - 1 ? (
                                    <Button
                                      onClick={() => remove(field.name)}
                                      style={{
                                        background: "#e26060ff",
                                        color: "white",
                                      }}
                                    >
                                      <MinusCircleOutlined className="dynamic-delete-button" />
                                    </Button>
                                  ) : null}
                                </Space>
                              </>
                            )}
                            <Divider />
                          </>
                        ))}
                      </>
                    )}
                  </Form.List>
                </Card>
              )}
            </Row>
            <Row>
              <Col>
                <Form.Item
                  name="attachments"
                  valuePropName="fileList"
                  getValueFromEvent={(e) => {
                    return e.fileList;
                  }}
                  // className="m-0"
                  style={{ paddingTop: "10px", margin: "0px" }}
                >
                  <Upload
                    multiple
                    maxCount={5}
                    accept={".png, .jpg, .jpeg, .pdf"}
                    beforeUpload={() => {
                      return false;
                    }}
                    onRemove={(e: any) => {
                      if (editAssetId && e?.id) {
                        setDeleteUploadId([...deleteUploadId, e?.id]);
                      }
                    }}
                    onPreview={(e: any) => {
                      console.log("data", e, e.type?.split("/"));
                      if (editAssetId && e?.path) {
                        setPreviewImage({
                          isBaseConvert: false,
                          path: e,
                        });
                      } else if (e.type?.split("/")[0] === "image") {
                        setPreviewImage({
                          isBaseConvert: true,
                          path: e,
                        });
                      }
                    }}
                  >
                    <Button
                      icon={<UploadOutlined />}
                      style={{ backgroundColor: "ButtonFace" }}
                    >
                      Uploads
                    </Button>
                  </Upload>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Drawer>

      {isModelOpen.type === "AddLocation" && (
        <AddAssetLocationModal
          onCancel={() => setIsModelOpen({ open: false, type: "" })}
          isModelOpen={isModelOpen.open}
          setAddAssLocation={setAddAssLocation}
        />
      )}
      {isModelOpen.type === "AddCategory" && (
        <AddAssetCategoryModal
          onCancel={() => setIsModelOpen({ open: false, type: "" })}
          isModelOpen={isModelOpen.open}
          setAddAssCategory={setAddAssCategory}
        />
      )}
      {isModelOpen.type === "AddEmployee" && (
        <AddEmpModel
          isModalOpen={isModelOpen.open}
          setIsModalOpen={() => setIsModelOpen({ open: false, type: "" })}
          setAddedEmployee={setAddedEmployee}
        />
      )}
      {previewImage.path && (
        <DocumentPreview
          open={true}
          onCancel={() =>
            setPreviewImage({
              path: "",
              isBaseConvert: false,
              // uploadType: "",
            })
          }
          documentDetails={previewImage}
        />
      )}
      {openModel.open && (
        <AddGroup
          open={openModel.open}
          editData={openModel?.param}
          onCancel={() => setOpenModel({ open: false, type: "" })}
          setTrigger={() => setGroupListTrigger(!groupListTrigger)}
          groupData={fixedAssetsGroups}
          type={SearchLedgerByGroupsTypes.FixedAssets}
          showName={"Fixed asset"}
          setAddGropVal={setAddGropVal}
        />
      )}
    </>
  );
};

export default AddAssetItems;

export const checkCategoryCheckboxMaintain = (
  type: boolean,
  value: string,
  editAssetId?: string
) => {
  if (editAssetId) {
    return type || value ? true : false;
  } else {
    return type;
  }
};
